/** This module is to allow location-specific filters to be used in other modules */

import _ from 'lodash';

/**
 * Filter locations by name or city.
 * @param {Array.<Location>} inputLocations Input location array.
 * @param {String} searchText The text to be matched.
 * @returns {Array.<Location>} The filtered location array.
 */
function locationSearchFilter(inputLocations, searchText) {
  if (!_.isString(searchText)) {
    return inputLocations;
  }

  const searchTextLower = searchText.toLowerCase();

  return inputLocations.filter(location => {
    let inputText = location.name;

    if (location.address.postal_area) {
      inputText += location.address.postal_area;
    }

    return inputText.toLowerCase().indexOf(searchTextLower) !== -1;
  });
}

/**
 * Filter locations by city.
 * @param {Array.<Location>} inputLocations Input location array.
 * @param {String} cityText The text to be matched.
 * @returns {Array.<Location>} The filtered location array.
 */
function cityFilter(inputLocations, cityText) {
  if (!_.isString(cityText)) {
    return inputLocations;
  }

  return inputLocations.filter(location => {
    return location.address.postal_area === cityText;
  });
}

/**
 * Filter locations by area.
 * @param {Array.<Location>} inputLocations Input location array.
 * @param {Number} area The area id to be matched.
 * @returns {Array.<Location>} The filtered location array.
 */
function areaFilter(inputLocations, area) {
  if (!area) {
    return inputLocations;
  }

  return inputLocations.filter(location => {
    return location.location_area === area;
  });
}

function serviceFilter(inputLocations, serviceId) {
  if (!serviceId) {
    return inputLocations;
  }
  return inputLocations.filter(location => location.services != null && location.services.includes(serviceId));
}
function offlineServiceFilter(inputLocations, serviceId) {
  if (!serviceId) {
    // Opposite to service filter, if service is not set, filter out completely
    return [];
  }
  return inputLocations.filter(location => location.other_services != null && location.other_services.includes(serviceId));
}

export {locationSearchFilter, cityFilter, areaFilter, serviceFilter, offlineServiceFilter};



// WEBPACK FOOTER //
// ./src/app/locations/location-filters.js